// all the values with $ will be overwritten from foreign configuration
const CONFIG = {
  NODE_ENV: '$NODE_ENV',
  VUE_APP_API_URL: '$VUE_APP_API_URL',
  VUE_APP_FILE_URL: '$VUE_APP_FILE_URL',
  VUE_APP_STRIPE_URL: '$VUE_APP_STRIPE_URL',
  VUE_APP_GOOGLE_API_KEY: '$VUE_APP_GOOGLE_API_KEY',
  VUE_APP_VERSION_NUMBER: '$VUE_APP_VERSION_NUMBER',
  VUE_APP_BRAND: '$VUE_APP_BRAND',
  VUE_APP_BRAND_COLOR: '$VUE_APP_BRAND_COLOR',
  VUE_APP_INFO_COLOR: '$VUE_APP_INFO_COLOR',
  VUE_APP_PRIMARYBTN_COLOR: '$VUE_APP_PRIMARYBTN_COLOR',
  VUE_APP_GOOGLE_ANALYTICS_4: '$VUE_APP_GOOGLE_ANALYTICS_4',
  VUE_APP_BRAND_TITLE: '$VUE_APP_BRAND_TITLE'
};

export default {
  value(key) {
    let value = CONFIG[key];

    // this value wasn't overwritten => get it from process.env
    if (value && value === '$' + key) {
      value = process.env[key];
    }

    return value;
  }
};
